import { useMutation } from "@apollo/client";

import { STAND_ATTCHMENT_DELETE } from "graphql/mutation/stand-gql";
import { successNotification, errorNotification } from "components/request-result";


const useMutationStandAttachmentDelete = ({
    showSuccessNotification = true,
    showErrorNotification = true,
    onCompleted = () => {},
    onError = () => {},
} = {}) => {
    const [ _setStandAttachmentDelete, { loading } ] = useMutation(STAND_ATTCHMENT_DELETE, {
        update(cache, { data }) {
            const payload = data?.attachmentDelete;
            if (showSuccessNotification && payload?.label) {
                successNotification({
                    title: payload.label,
                    description: payload.message,
                });
            }
            onCompleted(payload);
        },
        onError(error) {
            if (showErrorNotification) {
                errorNotification(error);
            }
            onError(error);
        },
    });

    return {
        _setStandAttachmentDelete,
        loadingMutationStandAttachmentDelete: loading,
    };
};

export default useMutationStandAttachmentDelete;
